/**
 * Hide element viually
 * @param {Element} element Element that should get hidden
 * @returns {void}
 */
export default (element) => {
  element.setAttribute('hidden', '');
  element.setAttribute('aria-hidden', 'true');
};
